import { createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.fixed.js";
import { defineComponent, unref } from 'vue';
import css from './AreaView.module.less';
var defineElementProps = function defineElementProps(props, className) {
  props = props || {};
  props["class"] = props["class"] || '';
  props["class"] += " ".concat(className);
  props.style = props.style || '';
};
export default defineComponent({
  props: {
    fixed: {
      type: Boolean,
      "default": true
    },
    scroll: {
      type: Boolean,
      "default": true
    }
  },
  setup: function setup(props, _ref) {
    var slots = _ref.slots;
    return function () {
      var header = slots.header && slots.header({});
      var footer = slots.footer && slots.footer({});
      if (header && header[0] && header[0].type === 'div') {
        defineElementProps(header[0].props, 'header-area-context');
      } else if (header && header[0] && header[0].children && header[0].children[0]) {
        defineElementProps(header[0].children[0].props, 'header-area-context');
      } else if (header && header[0]) {
        defineElementProps(header[0].props, 'header-area-context');
      }
      if (footer && footer[0] && footer[0].type === 'div') {
        defineElementProps(footer[0].props, 'footer-area-context');
      } else if (footer && footer[0] && footer[0].children && footer[0].children[0]) {
        defineElementProps(footer[0].children[0].props, 'footer-area-context');
      } else if (footer && footer[0]) {
        defineElementProps(footer[0].props, 'header-area-context');
      }
      return _createVNode("div", {
        "class": [css.AreaView, unref(props).fixed ? css.fixed : ''].join(' ')
      }, [header && _createVNode("div", {
        "class": [css.AreaViewHeader]
      }, [header]), _createVNode("div", {
        "class": [css.AreaViewBody, props.scroll ? "".concat(css.scroll) : '']
      }, [slots["default"] && slots["default"]()]), slots.overlay && slots.overlay(), footer && _createVNode("div", {
        "class": [css.AreaViewFooter]
      }, [footer])]);
    };
  }
});